import React, { useCallback, useState, useRef } from 'react'
import { Breadcrumb } from 'react-breadcrumbs'
import { useRouteMatch, useParams } from 'react-router-dom'

import CityPage from 'Containers/City/Page'

import { InventoryWrapper } from './components/InventoryWrapper'
import Table from './components/Table'
import AddModal from './components/AddModal'
import EditModal from './components/EditModal'
import DeleteModal from './components/DeleteModal'

const Inventory = props => {
  const { cityName } = props
  const { cityId } = useParams()
  const match = useRouteMatch()
  const tableRef = useRef()
  const [activeModal, setActiveModal] = useState({})

  const onDeleteModalConfirm = useCallback(() => {
    tableRef.current.reloadData()
    onHideModal()
  }, [])

  const onEditModalConfirm = useCallback(() => {
    tableRef.current.reloadData()
    onHideModal()
  }, [])

  const onAddModalConfirm = useCallback(() => {
    tableRef.current.reloadData()
    onHideModal()
  }, [])

  const onShowModal = useCallback(
    (name, data) => setActiveModal({ name, data }),
    [],
  )

  const onHideModal = useCallback(() => setActiveModal({}), [])

  return (
    <CityPage cityId={cityId} cityName={cityName}>
      <Breadcrumb data={{ title: 'Inventory', pathname: match.url }} />
      <InventoryWrapper>
        <Table showModal={onShowModal} ref={tableRef} />
        {activeModal.name === 'add' && (
          <AddModal
            cityId={cityId}
            handleConfirm={onAddModalConfirm}
            handleCancel={onHideModal}
          />
        )}
        {activeModal.name === 'edit' && (
          <EditModal
            cityId={cityId}
            item={activeModal.data}
            handleConfirm={onEditModalConfirm}
            handleCancel={onHideModal}
          />
        )}
        {activeModal.name === 'delete' && (
          <DeleteModal
            cityId={cityId}
            item={activeModal.data}
            handleConfirm={onDeleteModalConfirm}
            handleCancel={onHideModal}
          />
        )}
      </InventoryWrapper>
    </CityPage>
  )
}

export default Inventory



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Inventory/index.js